//描述：搜索结果列表
//时间：2017-4-15
//作者：bai.zhiming
"use strict";
angular.module("hotSearchListModule", []).controller("hotSearchListCtrl", ["$scope", "$q", "$stateParams", "initComDataService", "trsHttpService", function($scope, $q, $stateParams, initComDataService, trsHttpService) {
    initStatus();
    requestData();


    function requestData() {
        if ($stateParams.type && $stateParams.type == 'search') {
            initData2();
            $scope.status.indexname = '检索';
        } else {
            initData();
        }
    }

    function initStatus() {
        $scope.page = {
            "startpage": 0,
            "PAGESIZE": 20,
            'currentpage': 0
        };
        // hotpointevent areahotpointevent
        if (!$stateParams.serviceid || $stateParams.serviceid == "hotpointevent") {
            $stateParams.serviceid = "hotpointevent";
            $scope.title_name = "全网热点分析";
        } else if ($stateParams.serviceid == "areahotpointevent") {
            $scope.title_name = "地域热点分析";
        }
        $scope.params = {
            typeid: "widget",
            serviceid: $stateParams.serviceid,
            modelid: "hotArtticleList",
            clusterid: $stateParams.clusterid,
            entityfield: $stateParams.entityfield,
            keyword: $stateParams.keyword,
            page_size: $scope.page.PAGESIZE,
            page_no: $scope.page.startpage,
        };
        $scope.status = {
            "timeRange": initComDataService.timeRange(),
            "jumpToPageNum": 1,
            "keyWords": '',
            'indexname': $stateParams.keyword,
        };
        $scope.data = {
            items: "",
            time: "",
        };
    }

    function initData() {
        var deferred = $q.defer();
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "get").then(function(data) {
            $scope.data.items = data.PAGEITEMS;
            $scope.page = {
                startpage: data.PAGEINDEX + 1,
                PAGESIZE: data.PAGESIZE,
                ITEMCOUNT: data.TOTALITEMCOUNT,
                PAGECOUNT: data.PAGETOTAL
            };

            return deferred.resolve(data);
        });
        return deferred.promise;
    }

    function initData2() {
        var params = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "searchhistoryeventlist",
            clusterid: $stateParams.clusterid,
            pagesize: $scope.page.PAGESIZE,
            startpage: $scope.params.page_no,
        };
        var deferred = $q.defer();
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            $scope.data.items = data.PAGEITEMS;
            $scope.page = {
                startpage: data.PAGEINDEX + 1,
                PAGESIZE: data.PAGESIZE,
                ITEMCOUNT: data.TOTALITEMCOUNT,
                PAGECOUNT: data.PAGETOTAL
            };

            return deferred.resolve(data);
        });
        return deferred.promise;
    }
    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.status.jumpToPageNum = $scope.page.startpage;
        $scope.params.page_no = $scope.page.startpage - 1;

        requestData();
    };
    $scope.jumpToPage = function() {
        if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
            $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
        }
        $scope.params.page_no = $scope.status.jumpToPageNum - 1;
        requestData();
    };
}]);
